import * as actionTypes from '../../Action/actionTypes';

export const saveUserGroupDetails=(data)=>{
  return {
    type: actionTypes.SAVE_USER_GROUP_DETAILS,
    value: data
  }
};
